import { createApp, provide, h } from 'vue'
import { DefaultApolloClient } from '@vue/apollo-composable'
import { ApolloClient, InMemoryCache } from '@apollo/client/core'

import { HttpLink, split } from "@apollo/client/core"
// import { WebSocketLink } from "@apollo/client/link/ws"
import { getMainDefinition } from "@apollo/client/utilities"

import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';

import App from './App.vue'
import './index.css'
import './assets/tailwind.css'
import router from './router'

const cache = new InMemoryCache()

const wsLink = new GraphQLWsLink(createClient({
    url: 'ws://sreng-food-recipe.herokuapp.com/graphql',
  }));

// Create an http link:
const httpLink = new HttpLink({
    uri: "https://sreng-food-recipe.herokuapp.com/graphql"
})

const link = split(
    // split based on operation type
    ({ query }) => {
        const definition = getMainDefinition(query)
        return (
            definition.kind === "OperationDefinition" &&
            definition.operation === "subscription"
        )
    },
    wsLink,
    httpLink
)


const apolloClient = new ApolloClient({
    cache,
    link,
})

const app = createApp({
    setup () {
        provide(DefaultApolloClient, apolloClient)
    },

    render: () => h(App),
}).use(router)

app.mount('#app');